export interface Listing {
  id: string;
  type: 'annonce' | 'produit';
  title: string;
  description: string;
  price: number | null;
  category: string;
  city: string;
  image: string;
  ownerId: string;
  sellerName: string;
  sellerAvatar: string;
  sellerPhone: string;
  verified: boolean;
  postedAt: string;
}

export const mockListings: Listing[] = [
  {
    id: 'l-1',
    type: 'produit',
    title: 'Téléphone Samsung Galaxy A54 - 128 Go',
    description: 'Téléphone en excellent état, avec chargeur et boîte d\'origine. Acheté il y a 6 mois, aucune rayure.',
    price: 180000,
    category: 'Électronique',
    city: 'Lomé',
    image: 'https://readdy.ai/api/search-image?query=Samsung%20smartphone%20product%20photography%20on%20clean%20light%20grey%20background%2C%20soft%20studio%20lighting%2C%20minimal%20ecommerce%20product%20shot%2C%20high%20detail&width=800&height=600&seq=listing-phone-01&orientation=landscape',
    ownerId: 'mock-seller-kofi',
    sellerName: 'Kofi Mensah',
    sellerAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20confident%20young%20African%20man%20wearing%20a%20smart%20casual%20shirt%2C%20soft%20natural%20studio%20lighting%2C%20clean%20warm%20neutral%20background%2C%20friendly%20smile%2C%20high%20detail%20editorial%20photography%2C%20sharp%20focus%20on%20face&width=200&height=200&seq=listing-avatar-01&orientation=squarish',
    sellerPhone: '+228 90 12 34 56',
    verified: true,
    postedAt: '2026-08-18',
  },
  {
    id: 'l-2',
    type: 'annonce',
    title: 'Service de couture sur mesure - robes et costumes',
    description: 'Couturière professionnelle avec 10 ans d\'expérience. Confection de robes de mariage, costumes, tenues traditionnelles.',
    price: null,
    category: 'Services',
    city: 'Lomé',
    image: 'https://readdy.ai/api/search-image?query=Professional%20tailor%20sewing%20colorful%20african%20fabric%20in%20bright%20workshop%2C%20warm%20natural%20light%2C%20craft%20photography&width=800&height=600&seq=listing-tailor-01&orientation=landscape',
    ownerId: 'mock-seller-abla',
    sellerName: 'Abla Kossi',
    sellerAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20smiling%20African%20woman%20with%20natural%20hair%20wearing%20an%20elegant%20colorful%20top%2C%20soft%20studio%20lighting%2C%20clean%20warm%20neutral%20background%2C%20friendly%20and%20approachable%20expression%2C%20high%20detail%20editorial%20photography&width=200&height=200&seq=listing-avatar-02&orientation=squarish',
    sellerPhone: '+228 91 55 44 33',
    verified: true,
    postedAt: '2026-08-17',
  },
  {
    id: 'l-3',
    type: 'produit',
    title: 'Ordinateur portable HP - Core i5, 8 Go RAM',
    description: 'PC portable en bon état, batterie neuve. Idéal pour le travail et les études.',
    price: 320000,
    category: 'Électronique',
    city: 'Sokodé',
    image: 'https://readdy.ai/api/search-image?query=Modern%20laptop%20on%20clean%20desk%20with%20soft%20studio%20lighting%2C%20minimal%20ecommerce%20product%20photography%2C%20neutral%20background&width=800&height=600&seq=listing-laptop-01&orientation=landscape',
    ownerId: 'mock-seller-yao',
    sellerName: 'Yao Akakpo',
    sellerAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20middle%20aged%20African%20man%20with%20a%20gentle%20expression%20wearing%20a%20light%20shirt%2C%20soft%20studio%20lighting%2C%20clean%20warm%20neutral%20background%2C%20high%20detail%20editorial%20photography%2C%20sharp%20focus%20on%20face&width=200&height=200&seq=listing-avatar-03&orientation=squarish',
    sellerPhone: '+228 90 22 11 00',
    verified: false,
    postedAt: '2026-08-16',
  },
  {
    id: 'l-4',
    type: 'annonce',
    title: 'Offre d\'emploi : serveur/serveuse (restaurant)',
    description: 'Restaurant à Lomé recherche un serveur ou une serveuse dynamique. Expérience souhaitée mais pas obligatoire.',
    price: null,
    category: 'Emploi',
    city: 'Lomé',
    image: 'https://readdy.ai/api/search-image?query=Restaurant%20interior%20with%20warm%20lighting%20and%20elegant%20table%20setting%2C%20hospitality%20industry%20photography%2C%20inviting%20atmosphere&width=800&height=600&seq=listing-resto-01&orientation=landscape',
    ownerId: 'mock-seller-palmier',
    sellerName: 'Restaurant Le Palmier',
    sellerAvatar: '',
    sellerPhone: '+228 90 88 77 66',
    verified: true,
    postedAt: '2026-08-15',
  },
  {
    id: 'l-5',
    type: 'produit',
    title: 'Vélo tout-terrain VTT - taille adulte',
    description: 'VTT en bon état, freins révisés, pneus neufs. Parfait pour la ville et les chemins.',
    price: 75000,
    category: 'Sport',
    city: 'Kara',
    image: 'https://readdy.ai/api/search-image?query=Mountain%20bike%20product%20photography%20on%20light%20neutral%20background%2C%20studio%20lighting%2C%20ecommerce%20shot%2C%20high%20detail&width=800&height=600&seq=listing-bike-01&orientation=landscape',
    ownerId: 'mock-seller-marcel',
    sellerName: 'Marcel Tchala',
    sellerAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20athletic%20African%20man%20smiling%2C%20wearing%20a%20casual%20t-shirt%2C%20soft%20studio%20lighting%2C%20clean%20neutral%20warm%20background%2C%20friendly%20approachable%20expression%2C%20high%20detail%20editorial%20photography&width=200&height=200&seq=listing-avatar-04&orientation=squarish',
    sellerPhone: '+228 90 33 22 11',
    verified: false,
    postedAt: '2026-08-14',
  },
  {
    id: 'l-6',
    type: 'annonce',
    title: 'Cours particuliers de mathématiques',
    description: 'Professeur expérimenté donne des cours de mathématiques pour collège et lycée, à domicile ou en ligne.',
    price: 15000,
    category: 'Éducation',
    city: 'Lomé',
    image: 'https://readdy.ai/api/search-image?query=Teacher%20explaining%20math%20on%20whiteboard%20in%20bright%20classroom%2C%20education%20photography%2C%20clean%20composition&width=800&height=600&seq=listing-math-01&orientation=landscape',
    ownerId: 'mock-seller-aya',
    sellerName: 'Aya Tchakondo',
    sellerAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20warm%20friendly%20African%20woman%20teacher%20wearing%20a%20modest%20professional%20outfit%2C%20soft%20studio%20lighting%2C%20clean%20neutral%20warm%20background%2C%20high%20detail%20editorial%20photography%2C%20sharp%20focus%20on%20face&width=200&height=200&seq=listing-avatar-05&orientation=squarish',
    sellerPhone: '+228 91 44 55 66',
    verified: true,
    postedAt: '2026-08-13',
  },
];